export default __webpack_public_path__ + "static/media/hemofarm.f1c9afed.png";